var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bp && _vm.ingredients.length)?_c('div',[(_vm.bp.md)?_c('ingredient-row',{attrs:{"ingredients":_vm.ingredients,"long-descriptions":_vm.longDescriptions}}):_c('ingredient-gallery',{attrs:{"ingredients":_vm.ingredients,"long-descriptions":_vm.longDescriptions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }